import React from 'react';
import { memo, useState } from "react";
import { Data } from "./components/Data";

export var AppList = memo(() => {
    var [currentIndex, setCurrentIndex] = useState(0);
    var [img_3d, setimg_3d] = useState(Data[0].img);
    
    var btn = (index) => {
        setCurrentIndex(index);
        setimg_3d(Data[index].img);
        let chkd = document.getElementsByClassName('list-font');
        for (var i = 0; i < chkd.length; i++) {
            chkd[i].classList.remove("checkd");
        }
        chkd[index].classList.add("checkd");
    }

    var handleSelectChange = (event) => {
        var selectedIndex = event.target.selectedIndex;
        btn(selectedIndex);
    }

    var showPreviousModel = () => {
        let newIndex = currentIndex > 0 ? currentIndex - 1 : Data.length - 1;
        btn(newIndex);
    }

    var showNextModel = () => {
        let newIndex = currentIndex < Data.length - 1 ? currentIndex + 1 : 0;
        btn(newIndex);
    }

    return (
        <div className="container mt-3">
            <div className="row">
                <div className="d-md-none mb-2 sp-model-list">
                    <select className="model-select w-100" onChange={handleSelectChange} value={Data[currentIndex].title}>
                        {Data.map((value, key) => {
                            return(
                                <option className="w-100" key={key}>{value.title}</option>
                            )
                        })}
                    </select>
                </div>
                <div className="col-8 vr-display-col">
                    <div className='vr-display'>
                        <div id="scene">
                            <a-scene embedded vr-mode-ui="enabled:">
                                <a-sky src={img_3d} rotation="0 0 0"></a-sky>
                            </a-scene>
                        </div>
                        <div className="bottom_btn">
                            <button type="button" onClick={showPreviousModel}><img src="./back.png" alt="前のモデルに戻る" /></button>
                            <p>{Data[currentIndex].title}</p>
                            <button type="button" onClick={showNextModel}><img src="./next.png" alt="次のモデルに進む" /></button>
                        </div>
                    </div>
                </div>
                <div className="col-4 d-none d-md-block">
                    <p className="second-font m-list-title">モデルList</p>
                    <div className="m-list mb-2">
                        {Data.map((value, key) => {
                            return(
                                <p type="button" className="list-font text-center wf-roundedmplus1c mb-3" tabIndex={key+1} key={key} onClick={() => btn(key)}>
                                    {value.title}
                                </p>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>        
    );

});
